import produce from 'immer';
import * as actionTypes from '../actions/actionTypes';
import { createId } from '../../utils/storeUtils';
import { ApiError, User, UsersActions } from '../../types';

export interface UsersReducer {
  users: User[];
  userGroupUsers: User[];
  loading: boolean;
  error: ApiError;
}

export const initialState: UsersReducer = {
  users: [],
  userGroupUsers: [],
  error: {
    status: false,
    message: null,
  },
  loading: false,
};

const reducer = (state: UsersReducer = initialState, action: UsersActions): UsersReducer => {
  switch (action.type) {
    case actionTypes.USERS_REQUEST_START:
      return produce(state, draft => {
        draft.loading = true;
      });
    case actionTypes.USERS_REQUEST_USERS_ERROR:
      return produce(state, draft => {
        draft.loading = false;
        draft.error.message = action.errorMessage || null;
        draft.error.status = true;
      });
    case actionTypes.USERS_UPDATE_USER:
      return produce(state, draft => {
        draft.users = draft.users.map(user => (user.id === action.userId ? action.user : user));
        draft.loading = false;
      });
    case actionTypes.USERS_ADD_USER: {
      const existingIds = state.users.map(user => user.id);
      let id: string;
      do {
        id = createId(8);
      } while (existingIds.includes(id));
      return produce(state, draft => {
        draft.users.push({
          email: '',
          name: '',
          phone_number: '',
          user_roles: { effective: [], user: [], user_group: [] },
          id,
          country_calling_code: '',
          newItem: true,
          modified: true,
          allowed_procurements: [],
          employee_id: '',
          allow_access_without_bank_id: false,
          prescheduled_onboarding_at: null,
          offboarding_at: null,
          inherited_invoicing_account: {
            name: '',
          },
        });
      });
    }
    case actionTypes.USERS_DELETE_USER:
      return produce(state, draft => {
        draft.users = draft.users.filter(user => user.id !== action.userId);
      });
    case actionTypes.USERS_DELETE_SAVED_USER:
      return produce(state, draft => {
        draft.users = draft.users.filter(user => user.id !== action.userId);
        draft.loading = false;
      });
    case actionTypes.USERS_GET_USERS_SUCCESS:
      return produce(state, draft => {
        draft.loading = false;
        draft.error = initialState.error;
        draft.users = action.users;
      });
    case actionTypes.USERS_GET_USERGROUP_USERS_SUCCESS:
      return produce(state, draft => {
        draft.loading = false;
        draft.error = initialState.error;
        draft.userGroupUsers = action.users;
      });
    default:
      return state;
  }
};

export default reducer;
